import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';


@Injectable({
  providedIn: 'root'
})
export class MetaService {
  private defaultDescription: string = 'A BLUKIT, contempla mais de 1500 itens de produtos, para as mais diversas utilidades e soluções para instalações hidráulicas.';
  private baseUrl: string = window.location.origin;

  constructor(private router: Router, private apiService: ApiService) { }

  getDescription() {
    return this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(async () => {
        const urlTree = this.router.parseUrl(this.router.url);
        const partesLink =
          urlTree.root.children['primary']?.segments.map(segment => segment.path) ?? [];

        const parte1 = partesLink[0];
        const parte2 = partesLink[1];
        const parte3 = partesLink[2];
        const parte4 = partesLink[3];

        switch (parte1) {
          case 'linhas' :
          if(!parte3 && !parte4){
            let category = await this.apiService.getCategoryByIdSlug(parte2);
            if(category){
              this.defaultDescription = `Blukit - ${category['nome']}`;
            } else{

              this.defaultDescription = `Blukit - Linha de Produtos`
            }
          } else if(parte3 && !parte4){
            let category = await this.apiService.getCategoryByIdSlug(parte3);
            if(category){
              this.defaultDescription = `Blukit - ${category['nome']}`;
            }
          } else if(parte4) {
            let category = await this.apiService.getCategoryByIdSlug(parte4);
            if(category){
              this.defaultDescription = `Blukit - ${category['nome']}`;
            }
          }
          break;
          case 'produto-detalhe' :
            //funcao para pegar nome do produto através do slug
          await this.getNameProductBySlug(parte2).then(value => {
            this.defaultDescription = `Blukit - ${value}`;
          })
          // this.defaultDescription = `Blukit - ${this.getNameProductBySlug(parte2)}`;
          break;
          case 'atendimento':
          this.defaultDescription = `Blukit - Atendimento`
            if(parte2){
              switch (parte2){
                case 'fale-conosco':
                  this.defaultDescription = `Blukit - Fale Conosco`
                break;
                case 'assistencia-tecnica':
                  this.defaultDescription = `Blukit - Assistencia técnica`
                break;
                case 'financeiro':
                  this.defaultDescription = `Blukit - Financeiro`
                break;
                case 'ouvidoria':
                  this.defaultDescription = `Blukit - Ouvidoria`
                break;
                case 'fale-conosco':
                  this.defaultDescription = `Blukit - Fale conosco`
                break;
                default: this.defaultDescription = `Blukit - Atendimento`
              }
            }
          break;
          case 'onde-encontrar':
          this.defaultDescription = `Blukit - Onde Encontrar`
          if(parte2){
            switch (parte2){
              case 'assistencia-tecnica':
              this.defaultDescription = `Blukit - Assistência técnica`
              break;
              case 'lojista-revendedores':
              this.defaultDescription = `Blukit - Lojistas / Revendedores`
              break;
              default: this.defaultDescription = `Blukit - Onde Encontrar`
            }
            break;
          }
          break;
          case 'sobre':
          this.defaultDescription = `Blukit - Sobre`
            if(parte2){
              switch (parte2){
                case 'sobre-download':
                this.defaultDescription = `Blukit - Downloads`
                break;
                default: this.defaultDescription = `Blukit - Sobre`
              }
            }
          break;
          case 'blog':
            this.defaultDescription = `Blukit - Blog`
          break;
          case '':
            default: this.defaultDescription = `Blukit - O lado inteligente da hidráulica.`

          break;
        }

        return this.defaultDescription;
      })
    );
  }
  async getNameProductBySlug(slug: string){
    let product = await this.apiService.loadProductBySlug(slug);

    return product
  }

  getCanonicalUrl() {
    return this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        const urlTree = this.router.parseUrl(this.router.url);
        if(urlTree.root.children['primary']){
          const path = urlTree.root.children['primary'].segments.map(segment => segment.path).join('/');
          return `${this.baseUrl}/${path}`;
        }
        return `${this.baseUrl}`
      })
    );
  }

  getOgUrl() {
    return this.getCanonicalUrl();
  }

}
